/**
 * Factory production-nesting settings, stored backend-side on the factory's
 * polymorphic settings morph under key `production_nesting`.
 * Paper dimensions and piece padding are INCHES; rotations are the ones the
 * auto-packer may apply to panels (subset of [90, 180]). Laser outlines are
 * specified in mm (the unit factories quote): a cut outline of configurable
 * width going outwards from every panel edge (Silverstar 4pt = 1.41mm;
 * Rajco 0.25mm), plus an optional offset "searching" outline (Rajco: 1mm
 * line offset 5mm out).
 */
export interface FactoryNestingSettings {
  paper_width: number;
  paper_length: number;
  allowed_rotations: number[];
  /** Gap between nested pieces (and sheet border), inches. Optional. */
  piece_padding?: number | null;
  /** Cut-outline band width, going outwards from the panel edge (mm). */
  cut_outline_width_mm?: number | null;
  /** Draw the offset searching outline around every panel. */
  search_outline?: boolean | null;
  /** Centerline distance of the searching line outside the panel (mm). */
  search_outline_offset_mm?: number | null;
  /** Thickness of the searching line (mm). */
  search_outline_width_mm?: number | null;
  /** Extra piece-label content (printed above the size in a smaller font). */
  label_order_no?: boolean | null;
  label_player?: boolean | null;
  label_panel?: boolean | null;
}

export const PRODUCTION_NESTING_KEY = 'production_nesting';
